import { Theme } from "@mui/material/styles";

export const typography = (
    theme: Theme,
    ownerState?: { fontSize?: string; fontWeight?: number; fontFamily?: string },
) => {
    const fontSize = ownerState?.fontSize || "1rem";
    const fontWeight = ownerState?.fontWeight || 100;
    const fontFamily = ownerState?.fontFamily || "Open Sans";
    return {
        fontSize,
        fontWeight,
        fontFamily,
    };
};

export const container = (theme: Theme, ownerState?: { gap?: number }) => {
    const gap = ownerState?.gap | 1;

    return { display: "flex", flexDirection: "column", gap: gap };
};
